import { DEFAULT_LANGUAGE, normalizeLanguage } from './languages';

export function helpManualUrl(language) {
    const lang = normalizeLanguage(language) || DEFAULT_LANGUAGE;
    return `./help/user-manual.html?lang=${lang}`;
}
